// add the beginning of your app entry
import 'vite/modulepreload-polyfill'
import { addInitialPluginsAndHydrate } from './utils/conditioner'
import './styles/global.scss'

///////////////////////////////
// Dynamic Lazy Load Modules //
///////////////////////////////
addInitialPluginsAndHydrate(document.documentElement)
